import React from "react";
/* import "../../App.css"; */
import ContactForm from "../ContactForm";

export default function Products() {
  return (
    <>
      <div className="principal-title-container contact-page">
        <h1 className="principal-title">CONTACT ME</h1>
      </div>

      <ContactForm />
    </>
  );
}
